/** @jsxImportSource ../../i18n */
import React from 'react';
import { cx } from '../../theme/cx';

// The five-line digest of a daily report, numbered in gold.
export const DigestLines = ({ lines, className }) => (
  <ol className={cx('space-y-2.5', className)}>
    {lines.map((line, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={i} className="flex gap-3 text-[15px] leading-relaxed text-fg-body">
        <span aria-hidden="true" className="num w-4 flex-shrink-0 text-right font-display text-gold-400">{i + 1}</span>
        <span className="min-w-0">{line}</span>
      </li>
    ))}
  </ol>
);

export const digestSignature = ({ source, author, kind }) => {
  if (source !== 'rapporteur') return 'Extrait du rapport';
  if (!author) return null;
  return kind === 'experts' ? `${author}, rapporteur du panel` : author;
};
